import store from "@/store"
import * as Cookie from "@/localCache/cookie";

/**
 * @description 路由守卫
 */
export function beforeEach(to, from, next) {
    const matchedRoutes = to.matched || []
    const needsLegacyLogin = matchedRoutes.some(route => route.meta?.needLogin) || to.meta?.needLogin
    const needsAuth = matchedRoutes.some(route => route.meta?.needAuth) || to.meta?.needAuth

    if (isAuthenticated() || (!needsLegacyLogin && !needsAuth)) {
        next()
        return
    }

    if (needsAuth) {
        next({ path: '/login', query: { redirect: to.fullPath } })
        return
    }

    next('/home')
}

/**
 * @description 判断是否已登录
 * @returns {boolean}
 */
function isAuthenticated() {
    if (store.getters.token) {
        return true
    } else {
        let token = Cookie.getToken();
        if (token) store.commit('SET_TOKEN', token);
        return !!token;
    }
}
